import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table, Badge } from 'react-bootstrap'
import Meta from '../components/Meta'

import {loadCourses} from '../actions/courseActions'

//import {eventTracker} from '../actions/trackerActions'

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  import { useNavigate } from 'react-router-dom';


export const PixaganLearnScreen = ({match, history}) => {

   

    
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const courselist = useSelector(state => state.courselist)
    const {courses} = courselist

    const [sectionType, setSectionType] = useState("all") 
    const [newModel, setNewModel] = useState("") 


    const selectPageRequest = (module_in) => {
        setSectionType(module_in)
        //dispatch(loadLecturesAdmin(module_in))
    }

    const navigateToPage = (pageURL) => {
        navigate(`/lectures/${pageURL}`)
    }
    






    useEffect(() => {
        dispatch(loadCourses())

       
        //var deviceType = isMobile ? 'mobilebrowser': 'webbrowser'

        //dispatch(eventTracker('Landing Page', 'page', deviceType, {}))

    }, [])



    return(
        <div style={{ marginTop: '0px', fontFamily: 'Inter, Roboto, "Open Sans", Arial, sans-serif', background: '#f8f9fa' }}>
            <Meta
                title={'Pixagan.AI'}
                description={
                    'Teaching you the fundamentals of Deep Learning and other Artifical Intelligence (AI) topics. We teach you the basic math topics that you will need to understand AI as well as the required Python coding. '
                }
            />

            {/* Hero Section */}
            {/* <section
                style={{
                    background: 'linear-gradient(90deg, #f0f2f2 60%, #e6e6fa 100%)',
                    padding: '60px 0 40px 0',
                    textAlign: 'center',
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                <h2
                    className="display-3 fw-bold mb-4"
                    style={{
                        marginBottom: 10,
                        fontSize: '2.2rem',
                        fontFamily: 'Roboto',
                        letterSpacing: '0.01em',
                    }}
                >
                    AI and Machine Learning tech is growing at breakneck speed
                </h2>
                <h3 className="lead mb-4" style={{ marginBottom: 30 }}>
                    Learn and stay up-to-date at
                </h3>
                <img
                    src="pixagan.png"
                    alt="Pixagan Logo"
                    style={{
                        width: isMobile ? '60vw' : '20vw',
                        margin: '20px 0',
                        borderRadius: '20px',
                        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                    }}
                />
               
            </section> */}

            {/* Courses Section */}
            <section style={{ padding: '40px 0', background: '#fff' }}>
                <Container>
                    <h2 style={{ fontWeight: 700, marginBottom: 30, textAlign: 'center', color: '#0C0854' }}>Courses</h2>
                    <Row xs={1} md={2} lg={3} className="g-4" style={{marginBottom:'20px'}}>
                        {courses &&
                            courses.map((course, index) => (
                                <Col key={course.url}>
                                    <Link to={`/courses/${course.url}`} style={{ textDecoration: 'none' }}>
                                        <Card
                                            style={{
                                                borderRadius: '18px',
                                                boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                minHeight: 420,
                                                border: 'none',
                                            }}
                                            className="h-100"
                                            onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)')}
                                            onMouseOut={e => (e.currentTarget.style.transform = 'none')}
                                        >
                                            <Card.Img
                                                variant="top"
                                                src={course.cover}
                                                alt={course.title}
                                                style={{
                                                    width: '100%',
                                                    height: '180px',
                                                    objectFit: 'cover',
                                                    borderTopLeftRadius: '18px',
                                                    borderTopRightRadius: '18px',
                                                    background: '#f0f2f2',
                                                }}
                                            />
                                            <Card.Body>
                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                                    <span className="h5" style={{ fontWeight: 600, color: '#0C0854', flex: 1 }}>
                                                        {course.title}
                                                    </span>
                                                    {course.isPosted === false && (
                                                        <Badge
                                                            style={{
                                                                backgroundColor: '#6b0752',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '8px',
                                                                fontSize: 14,
                                                                marginLeft: 8,
                                                            }}
                                                        >
                                                            Coming Soon
                                                        </Badge>
                                                    )}
                                                </div>
                                                <p style={{ color: '#333', fontSize: 16, minHeight: 60 }}>{course.description}</p>
                                            </Card.Body>
                                        </Card>
                                    </Link>
                                </Col>
                            ))}
                    </Row>
                </Container>
            </section>

            {/* Tools Section */}
            <section style={{ backgroundColor: '#f0f2f2', padding: '40px 0' }}>
                <Container>
                    <h2 style={{ fontWeight: 700, marginBottom: 30, textAlign: 'center', color: '#0C0854' }}>
                        Related Open Source Tools
                    </h2>
                    <Row className="g-4">
                        <Col md={6}>
                            <Card style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '16px', border: 'none', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                                <Link to="/deeproots" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <p className="h5" style={{ fontWeight: 600, color: '#6b0752' }}>
                                        Deeproots
                                    </p>
                                    <p style={{ color: '#333' }}>
                                        Deeproots is an open-source neural network library built in python designed to make setting up and training neural networks easy for beginners.
                                    </p>
                                </Link>
                            </Card>
                        </Col>
                        {/* <Col md={6}>
                            <Card style={{ backgroundColor: '#fff', padding: '24px', borderRadius: '16px', border: 'none', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                                <Link to="/laeyerz" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <p className="h5" style={{ fontWeight: 600, color: '#6b0752' }}>
                                        Laeyerz
                                    </p>
                                    <p style={{ color: '#333' }}>
                                        Laeyerz is a library that makes it possible to quickly prototype and visualize AI LLM applications.
                                    </p>
                                </Link>
                            </Card>
                        </Col> */}
                    </Row>
                </Container>
            </section>

            {/* About Section */}
            {/* <section style={{ padding: '40px 0', background: '#fff' }}>
                <Container>
                    <h2 style={{ fontWeight: 700, marginBottom: 20, textAlign: 'center', color: '#0C0854' }}>About Us</h2>
                    <p className="h5" style={{ color: '#333', textAlign: 'center', maxWidth: 700, margin: '0 auto 10px auto' }}>
                        Pixagan.AI was founded by Dr Anil Variyar with the objective of making it easy for everyone to understand and access the basics of AI, and more specifically, Deep Learning
                    </p>
                    <p className="h5" style={{ color: '#333', textAlign: 'center', maxWidth: 700, margin: '0 auto' }}>
                        Anil has a PhD in Aeronautics and Astronautics from Stanford University.
                    </p>
                </Container>
            </section> */}
        </div>
    )


}

export default PixaganLearnScreen


